import React, { FC } from 'react';
import { useTheme } from '@mui/material';
import moment from 'moment';
import { useSelector } from 'react-redux';

import { IDepartmentScheduleDTO, IPartialAbsenceInfoDTO, IStartEndDateDTO } from 'src/api/dtos';
import { EmployeesIcon } from 'src/assets/img/icons';
import { useTranslate } from 'src/shared/providers';
import { formatEmployeeName } from 'src/shared/utils';
import { getTimeFormat } from 'src/store/user/user.selectors';

interface Props {
  departmentSchedules: IDepartmentScheduleDTO[];
}

export const CalendarPeerSchedules: FC<Props> = ({ departmentSchedules }) => {
  const theme = useTheme();
  const { t } = useTranslate();
  const timeFormat = useSelector(getTimeFormat);

  const formatShifts = (shift: IStartEndDateDTO | IPartialAbsenceInfoDTO) => {
    if ('startDate' in shift && 'endDate' in shift) {
      return `${moment(shift.startDate).format(timeFormat)} - ${moment(shift.endDate).format(timeFormat)}`;
    }
    return `${moment(shift.startTime).format(timeFormat)} - ${moment(shift.endTime).format(timeFormat)}`;
  };

  return (
    <div style={{ marginLeft: '-30px' }}>
      <div className="d-flex align-items-center mb-3">
        <EmployeesIcon color="#6C757D" width={24} height={24} className="me-2" />
        <span className="fw-500 me-1">{t('calendar.myPeersSchedules')}</span>
      </div>
      {departmentSchedules.map((schedule, index) => (
        <div
          key={`schedule-${schedule.employeeDisplayName}-${index}`}
          style={{ marginLeft: '0px' }}
          className={`monthly-event first last info ${theme.palette.mode} mb-2`}
        >
          <span className="w-100 event-title">
            {formatEmployeeName(schedule.employee)} {schedule.shifts.map((shift) => formatShifts(shift)).join(', ')}
          </span>
        </div>
      ))}
    </div>
  );
};
